import { computed, useAttrs } from 'vue';

export const useForwardedAttrs = () => {
  const LAYOUT_ATTRS = new Set(['class', 'style']);
  const isLayout = ([key]: [string, unknown]) => LAYOUT_ATTRS.has(key);
  const isListener = ([key]: [string, unknown]) => /^on[A-Z]/.test(key);

  const attrs = useAttrs();
  const entries = computed(() => Object.entries(attrs).filter(([key]) => key !== 'data-state'));

  const wrapperAttrs = computed(() => Object.fromEntries(entries.value.filter(isLayout)));
  const listenerAttrs = computed(() => Object.fromEntries(entries.value.filter(isListener)));
  const staticAttrs = computed(() => Object.fromEntries(entries.value.filter((e) => !isLayout(e) && !isListener(e))));
  const controlAttrs = computed(() => Object.fromEntries(entries.value.filter((e) => !isLayout(e))));

  return { wrapperAttrs, controlAttrs, staticAttrs, listenerAttrs };
};
